module.exports = __webpack_public_path__ + "static/media/play_button.58c806c4.svg";